import { useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { selectCurrentEventId } from "../selectors";
import { resetUsersInEvent } from "./actions";
import {
  makeSelectEventIdOfUsersInEvent,
  makeSelectUsersInEventIsLoaded,
} from "./selectors";
import { getUsersInEvent } from "./usersInEvent.firebase";

const UsersInEventSubscriber = () => {
  const isLoaded = useSelector(makeSelectUsersInEventIsLoaded());
  const eventIdOfUsersInEvent = useSelector(makeSelectEventIdOfUsersInEvent());
  const eventId = useSelector(selectCurrentEventId);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (eventId) {
      // If user is switching event then reset the data
      if (eventId !== eventIdOfUsersInEvent) {
        dispatch(resetUsersInEvent());
      }

      if (!isLoaded) {
        getUsersInEvent(eventId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, eventIdOfUsersInEvent]);

  return null;
};

export default memo(UsersInEventSubscriber);
